import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import app from "./modules/app";
import permission from "./modules/permission";
import settings from "./modules/settings";
import user from "./modules/user";
import coupon from "./modules/coupon";
import pageRecorder from "./modules/pageRecorder";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    permission,
    settings,
    user,
    coupon,
    pageRecorder,
  },
  getters,
});

export default store;
